<template>
    <div style="display: flex;flex-direction: column;
    height: 100%;
    ">
        <div :style="{ height: contentHeight + 'px' }" style="width: 100%;overflow: auto;  scrollbar-width: none;
  -ms-overflow-style: none;display: flex;align-items: center; ">
            <div class="columnformat">
                <div
                    style="display: flex;flex-direction: column;align-items: center;width: 100%;background:white;box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);">
                    <div
                        style="width: calc(100% - 10px);text-align: left;padding-left: 10px;padding-top: 10px;padding-bottom: 10px;background:#FFE988;font-weight: 700;">
                        花花商城 </div>


                </div>
                <div id="goodBar"
                    style="padding-top:10px;width: 100%;display: flex;flex-wrap: wrap;justify-content: space-around;">
                    <div v-for="item, index in goodList" style="width:45%;margin-bottom: 10px;"
                        >
                        <div v-if="item.goodName!=null" style="
                    width: calc(100% - 10px);
                    background:white;
                    box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);
                    display: flex;
                    flex-direction: column;
                    padding: 5px;
                    border-radius: 5px">
                            <img :src="resourceBase + '/assets/goodImg/' + item.goodImg.split(';')[0]"
                                style="width: 100%;height: 100px; object-fit: contain;background: black;" alt="">
                            <div style="width: 100%;text-align: left;">水晶手串,广州特工,顶级优惠</div>
                            <div style="width: 100%;display: flex;flex-direction: column;margin-top: 10px;">
                                <div style=" text-align: left;color: red;">¥68</div>
                                <div
                                    style=" text-decoration: line-through;text-align: left;color: grey;font-size: small;">
                                    ¥198</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>


    </div>

</template>

<style scoped>
.columnformat {

    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F0F5F4;
    overflow: auto;
}
</style>

<script>
import request from "../axios/request";
export default {
    data() {
        return {
            contentHeight: null,
            resourceIp: null,
            resourceBase: /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname) ? 'https://yuanhuihuanhuan.com' : window.location.origin,
            goodList: []
        }
    },
    mounted() {
        const resizeObserver = new ResizeObserver((entries) => {
            requestAnimationFrame(() => {
                for (const entry of entries) {

                    this.contentHeight = window.innerHeight - 50 - this.$store.state.indexBarHeight
                }
            });
        });
        resizeObserver.observe(document.getElementById("goodBar"));

        this.resourceIp = this.extractIPFromURL(window.location.origin);
        this.getGoodList()
    },
    methods: {
        extractIPFromURL(url) {
            try {
                // 方法1：优先使用浏览器原生URL对象解析（兼容现代浏览器）
                const parsedUrl = new URL(url);
                const hostname = parsedUrl.hostname;

                // 如果是IPv6地址（如[2001:db8::1]），去除方括号
                if (hostname.startsWith('[') && hostname.endsWith(']')) {
                    return hostname.slice(1, -1);
                }

                // 如果是IPv4地址或域名，直接返回
                return hostname;
            } catch (e) {
                // 方法2：URL对象解析失败时，使用正则表达式作为兜底方案
                const ipv4Regex = /(?:\d{1,3}\.){3}\d{1,3}/; // 匹配IPv4
                const domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/i; // 匹配域名[1,4](@ref)

                // 尝试匹配IPv4
                const ipMatch = url.match(ipv4Regex);
                if (ipMatch) return ipMatch[0];

                // 尝试匹配域名
                const domainMatch = url.match(domainRegex);
                if (domainMatch && domainMatch[1]) {
                    return domainMatch[1].replace(/^www\./, ''); // 可选：去除www前缀
                }

                return null; // 均未匹配时返回null
            }
        },
        async getGoodList() {
            let res = await request({
                url: "/good/api/getGoodList",
                method: "GET"
            })
            if (res.data.status == 200) {
                this.goodList = res.data.data
            }
        }
    }
}
</script>
